(() => {
  // Verified destination H1, 2026-10-14; do not infer item names from URL slugs.
  const verifiedProductNames = new Map([
    ['/products/usa-made-handmade-pearl-flower-girl-headband', 'Handmade Pearl Flower Girl Headband Made in USA'],
  ]);
  const nameLinks = (root) => {
    const links = [...root.querySelectorAll('.product__description a[href]')];
    if (root.matches?.('.product__description a[href]')) links.unshift(root);
    // Images can also be added inside an existing description link.
    const parentLink = root.closest?.('.product__description a[href]');
    if (parentLink && !links.includes(parentLink)) links.push(parentLink);
    for (const link of links) {
      if (link.hasAttribute('aria-label') || link.hasAttribute('aria-labelledby') || link.textContent.trim()) continue;
      const images = [...link.querySelectorAll('img')];
      if (!images.length || images.some((image) => image.alt.trim())) continue;
      let name = link.title.trim();
      if (!name) {
        const target = new URL(link.href, location.origin);
        if (target.origin === location.origin) name = verifiedProductNames.get(target.pathname) || '';
      }
      if (name) link.setAttribute('aria-label', name);
    }
    // Old description markup can contain a link with no content or authored name.
    // Remove only that empty focus target; keep every image, icon and named link.
    const emptyLinks = [...root.querySelectorAll('.product__description a[href]')];
    if (root.matches?.('.product__description a[href]')) emptyLinks.unshift(root);
    for (const link of emptyLinks) {
      if (link.children.length || link.textContent.trim() || link.hasAttribute('title') ||
          link.hasAttribute('aria-label') || link.hasAttribute('aria-labelledby')) continue;
      if ([...link.attributes].some(({ name }) => !['href', 'rel', 'target'].includes(name))) continue;
      link.remove();
    }
  };
  nameLinks(document);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) nameLinks(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
